// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","inner":"inner__NMw3c","logo":"logo__jPF5-","active":"active__r+Z6z"};